import { HttpClient } from "@angular/common/http";
import { constantvalues, Role } from "../../const";
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment.development'

@Injectable({
    providedIn: 'root'
})

export class AccountAdminCenterService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getUserDetails(payload: any){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_ACCOUNT_ADMIN}`, {params: payload});
    }
    
    createUser(userDetails: any[]){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CREATE_ACCOUNT_ADMIN}/${Number(Role.AccountAdmin)}`, userDetails);
    }

    editUser(userDetails: any){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.EDIT_ACCOUNT_ADMIN}`, userDetails);
    }

    deleteOrRecoverUser(userId: string, toDelete: boolean = false){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.DELETE_ACCOUNT_ADMIN}`, {
            params: {
                userId: userId,
                delete: toDelete
            }
        })
    }

    deleteUser(userId: string){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.DELETE_USER}/${userId}`, {
            params: {
                userId: userId
            }
        })
    }
}